<template>
  <div>
    <v-dialog
      v-if="!$auth.loggedIn"
      :value="signupDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      class="btn-dialogue"
      persistent
      width="60%"
      scrollable
    >
      <v-card class="blue-purple-gradient">
        <v-card-title style="color: white;">
          <span>{{ $t('navbar.signup.form.create_account_as') }}</span>
          <v-spacer />
          <v-btn class="ma-0" text icon @click="toggleSignupDialog">
            <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- <login-form /> -->
          <v-layout id="selectLoginType" row nowrap>
            <v-flex class="pa-3" xs12 sm12 md6>
              <v-btn
                color="white"
                class="pa-6"
                style="width: 100%;height: 100%;"
                @click="toggleStudentSignupDialog"
              >
                <div>
                  <h4 style="text-transform: capitalize;">
                    {{ $t('navbar.signup.form.student') }}
                  </h4>
                  <p style="white-space: normal;text-transform: capitalize;">
                    {{ $t('navbar.signup.form.student_details') }}
                  </p>
                </div>
                <div>
                  <img
                    src="/img/IMG-9472.png"
                    lazy-src="/img/IMG-9472.png"
                    style="max-width: 100%;max-height: 250px;"
                  />
                </div>
              </v-btn>
            </v-flex>
            <v-flex class="pa-3" xs12 sm12 md6>
              <div style="height: 100%;">
                <v-btn
                  color="white"
                  class="pa-6"
                  style="width: 100%;height: 100%;"
                  @click="toggleTeacherSignupDialog(true)"
                >
                  <div>
                    <h4 style="text-transform: capitalize;">
                      {{ $t('navbar.signup.form.teacher') }}
                    </h4>
                  </div>
                  <p style="white-space: normal;text-transform: capitalize;">
                    {{ $t('navbar.signup.form.teacher_details') }}
                  </p>
                </v-btn>
              </div>
              <!-- <div class="pt-6" style="height: 50%;">
                <v-btn
                  color="white"
                  class="pa-6"
                  style="width: 100%;height: 100%;"
                  @click="toggleTeacherSignupDialog(false)"
                >
                  <div>
                    <h4 style="text-transform: capitalize;">
                      {{ $t('navbar.signup.form.regular') }}
                    </h4>
                    <p style="white-space: normal;text-transform: capitalize;">
                      {{ $t('navbar.signup.form.regular_details') }}
                    </p>
                  </div>
                </v-btn>
              </div> -->
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider style="border-color: rgb(255 255 255 / 12%);" />
        <v-card-actions class="text-center">
          <v-flex class="text-center py-2" style="color:white">
            {{ $t('navbar.login.form.already_have_an_account') }}
            <a
              @click="changeForms"
              style="color:white;text-decoration: underline;"
            >
              {{ $t('navbar.login.form.log_in_here') }}
            </a>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Student -->
    <v-dialog
      v-if="!$auth.loggedIn"
      :value="studentSignupDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      class="btn-dialogue"
      persistent
      width="500"
      scrollable
    >
      <v-card>
        <v-card-title class="blue-purple-gradient">
          <span>{{ $t('navbar.signup.form.join_classroom_title') }}</span>
          <v-spacer />
          <v-btn class="ma-0" text icon @click="toggleSignupDialog">
            <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <!-- <login-form /> -->
          <v-stepper
            v-model="studentstep"
            vertical
            class="pb-0 pt-3"
            style="box-shadow: none;"
          >
            <v-stepper-step :complete="studentstep > 1" step="1" editable>
              {{ $t('navbar.signup.form.join_classroom_title') }}
              <small>{{ $t('navbar.signup.form.join_classroom') }}</small>
            </v-stepper-step>

            <v-stepper-content step="1">
              <join-class-form @next-step="goNextStep" />
            </v-stepper-content>
            <v-stepper-step :complete="studentstep > 2" step="2">
              {{ $t('navbar.signup.form.create_account') }}
            </v-stepper-step>

            <v-stepper-content step="2">
              <signup-form
                :classcode="classcode"
                account-type="s"
                :forward-to-classroom="forwardToClassroom"
                scope="student-signup-form"
              />
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
        <v-divider />
        <v-card-actions class="text-center">
          <v-flex class="text-center py-2">
            {{ $t('navbar.login.form.already_have_an_account') }}
            <a @click="changeForms">
              {{ $t('navbar.login.form.log_in_here') }}
            </a>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TEACHER -->
    <v-dialog
      v-if="!$auth.loggedIn"
      :value="teacherSignupDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      class="btn-dialogue"
      persistent
      width="500"
      scrollable
    >
      <v-card>
        <v-card-title class="blue-purple-gradient">
          <span v-if="forwardToClassroom">{{
            $t('navbar.signup.form.create_teacher_account')
          }}</span>
          <span v-else>{{ $t('navbar.signup.form.create_account') }}</span>
          <v-spacer />
          <v-btn class="ma-0" text icon @click="toggleSignupDialog">
            <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-3">
          <signup-form
            class="mt-3"
            scope="signup-form"
            account-type="r"
            :forward-to-classroom="forwardToClassroom"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions class="text-center">
          <v-flex class="text-center py-2">
            {{ $t('navbar.login.form.already_have_an_account') }}
            <a @click="changeForms">
              {{ $t('navbar.login.form.log_in_here') }}
            </a>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Login -->
    <v-dialog
      v-if="!$auth.loggedIn"
      :value="loginDialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      class="btn-dialogue"
      persistent
      width="500"
      scrollable
    >
      <v-card>
        <v-card-title class="blue-purple-gradient">
          <span>Login</span>
          <v-spacer />
          <v-btn class="ma-0" text icon @click="toggleLoginDialog">
            <v-icon color="white">$vuetify.icons.mdiClose</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <login-form />
        </v-card-text>
        <v-divider />
        <v-card-actions class="text-center">
          <v-flex class="text-center py-2">
            {{ $t('navbar.login.form.not_have_an_account') }}
            <a @click="changeForms">
              {{ $t('navbar.login.form.sign_up_here') }}
            </a>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import JoinClassForm from '~/components/forms/classroom/JoinClassForm'
import SignupForm from '~/components/forms/account/SignupForm'
import { mapState } from 'vuex'
export default {
  components: {
    JoinClassForm,
    SignupForm,
    'login-form': () => import('~/components/forms/account/LoginForm.vue'),
  },
  data() {
    return {
      changePlanDialog: false,
      classcode: '',
      studentstep: 1,
      forwardToClassroom: false,
      transparentPages: [
        '/features',
        '/about',
        '/educators',
        '/artists',
        '/researchers'
      ]
    }
  },
  computed: {
    ...mapState(['loginDialog']),
    ...mapState(['signupDialog']),
    ...mapState(['studentSignupDialog']),
    ...mapState(['teacherSignupDialog'])
  },
  methods: {
    getWriteRoute() {
      if (this.$auth.loggedIn && this.$auth.user.is_student) {
        return '/'
      } else {
        return '/studio'
      }
    },
    goNextStep(value) {
      this.studentstep = 2
      this.classcode = value
    },
    toggleLoginDialog() {
      this.$store.dispatch('setLoginDialog', !this.$store.state.loginDialog)
    },
    toggleStudentSignupDialog() {
      this.$store.dispatch(
        'setStudentSignupDialog',
        !this.$store.state.studentSignupDialog
      )
    },

    toggleTeacherSignupDialog(forwardToClassroom) {
      this.forwardToClassroom = forwardToClassroom
      this.$store.dispatch(
        'setTeacherSignupDialog',
        !this.$store.state.teacherSignupDialog
      )
    },
    toggleSignupDialog() {
      this.$store.dispatch('setSignupDialog', !this.$store.state.signupDialog)
    },
    changeForms() {
      if (
        this.$store.state.teacherSignupDialog ||
        this.$store.state.studentSignupDialog
      ) {
        this.toggleSignupDialog()
      }
      this.toggleSignupDialog()
      this.toggleLoginDialog()
    }
  }
}
</script>